import { colors, Grid, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import { formatCurrency } from "helpers/utils";

import { totalsType } from "..";

interface Props {
  totals: totalsType;
}

export default function TaxasBancarias({ totals }: Props) {
  const taxaPix = totals.taxaBancaria.pix.taxa;
  const taxaBoleto = totals.taxaBancaria.boleto.taxa;
  const taxaCartao = totals.taxaBancaria.cartao.taxa;

  const TOTAL_TAXA_PIX = formatCurrency(totals.taxaBancaria.pix.total);
  const TOTAL_TAXA_BOLETO = formatCurrency(totals.taxaBancaria.boleto.total);
  const TOTAL_TAXA_CARTAO = formatCurrency(totals.taxaBancaria.cartao.total);

  return (
    <>
      <MDBox
        bgColor={colors.blueGrey[50]}
        p={1}
        px={2}
        my={2}
        borderRadius="lg"
      >
        <Grid container spacing={0}>
          <Grid item xs={12} md={4} lg={6}>
            <Typography variant="overline" fontWeight="bold">
              Taxas bancárias
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            lg={3}
            container
            display="flex"
            alignItems="center"
            justifyContent="right"
          >
            <Typography variant="overline" textAlign="right" fontWeight="bold">
              Taxa
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            lg={3}
            container
            display="flex"
            alignItems="center"
            justifyContent="right"
          >
            <Typography variant="overline" textAlign="right" fontWeight="bold">
              Total
            </Typography>
          </Grid>
        </Grid>
      </MDBox>

      <MDBox px={3}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={4} lg={6}>
            <Typography variant="body2">Pix</Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right">
              {taxaPix}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right" fontWeight="bold">
              {TOTAL_TAXA_PIX}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} lg={6}>
            <Typography variant="body2">Boleto</Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right">
              {formatCurrency(taxaBoleto)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right" fontWeight="bold">
              {TOTAL_TAXA_BOLETO}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} lg={6}>
            <Typography variant="body2">Cartão de crédito</Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right">
              {taxaCartao}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Typography variant="body2" textAlign="right" fontWeight="bold">
              {TOTAL_TAXA_CARTAO}
            </Typography>
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
}
